<template>
  <button
    class="cohort-entry-button"
    :class="{ 'cohort-entry-button--collapsed': collapsed }"
    :title="L.cohort_experience_research"
    @click="router.push('/cohorts')"
  >
    <ChartBarSquareIcon class="cohort-entry-button__icon" />
    <span v-if="!collapsed" class="cohort-entry-button__label">{{ L.cohort_experience_research }}</span>
  </button>
</template>

<script setup>
import { L } from '@/plugins/utils/i18n';
import { ChartBarSquareIcon } from '@heroicons/vue/24/outline'
import { useRouter } from 'vue-router'

defineProps({ collapsed: Boolean })
const router = useRouter()
</script>

<style scoped>
.cohort-entry-button {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0.625rem 0.75rem;
  border: 1px solid #dbeafe;
  border-radius: 0.5rem;
  background: #eff6ff;
  color: #2563eb;
  font: inherit;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  cursor: pointer;
  transition: background-color 150ms ease;
}

.cohort-entry-button:hover {
  background: #dbeafe;
}

.cohort-entry-button--collapsed {
  justify-content: center;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.cohort-entry-button__icon {
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
}

.cohort-entry-button__label {
  margin-left: 0.5rem;
}
</style>
